import { Box, styled, Typography } from '@mui/material'
import { isString } from 'lodash'
import { FC, ReactNode } from 'react'
import { theme } from '../../../../theme'

interface Props {
    icon?: ReactNode
    title: ReactNode
    description: ReactNode
    imageSrc?: string
}

const StyledImage = styled('img')(() => ({
    width: '228px',
    height:' 164px',
    borderRadius: '16px',
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
        marginLeft: '0',
    },
}))

const MessageInfoCard: FC<Props> = ({ icon, title, description, imageSrc }) => {
    return (
        <Box
            sx={{
                alignItems: 'center',
                maxHeight: '700px',
                display: 'flex',
                borderRadius: '20px',
                backgroundColor: '#F9FAFB',
                alignContent: 'baseline',
                padding: '0',
                gap: '12px',
                [theme.breakpoints.down('sm')]: {
                    flexDirection: 'column',
                },
            }}>
            {icon ? (
                <Box
                    sx={{
                        padding: '10px 0',
                        [theme.breakpoints.down('sm')]: {
                            padding: '0',
                        },
                    }}>
                    {icon}
                </Box>
            ) : null}

            <Box
                sx={{
                    display: 'flex',
                    width: '80%',
                    flexDirection: 'column',
                    gap: '8px',
                    // padding: '10px 0',
                    [theme.breakpoints.down('sm')]: {
                        padding: '0',
                    },
                }}>
                {isString(title) ? <Typography variant="h6" mb={'4px'}>{title}</Typography> : title}
                {isString(description) ? (
                    <Typography color="#1B1C1D" variant="body2">
                        {description}
                    </Typography>
                ) : (
                    description
                )}
            </Box>
            {imageSrc ? <StyledImage src={imageSrc} /> : null}
        </Box>
    )
}

export default MessageInfoCard
